export const LOADING_DOCUMENT = "LOADING_DOCUMENT";
export const FILE_SHARING = "FILE_SHARING";